import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutEdiLtxExpressProfLookup extends Layout {
    sourceEdiLtxexpressProf: DataSource;
    table1: Table;
}
